module.exports = __webpack_public_path__ + "img/Group 4166.e116b0e6.svg";